/**
 * Created by minimus on 24.12.2014.
 */
(function ($) {
  const lookup = [];
  let cPid = 0;
  const ejLocale = (options.locale.changeLocale) ? options.locale.locale : 'en-US';
  const localeStrings = options.strings;
  $(document).ready(function () {
    let dmAds;
    let listGrid;
    const adsDialog = $('#adsDialog').ejDialog({
      width: 830,
      allowDraggable: true,
      enableModal: true,
      showOnInit: false
    }).data('ejDialog');
    const adsSel = new Selectors();

    function getList(pid) {
      cPid = pid;
      dmAds = ej.DataManager({
        url: `${ajaxurl}?action=list_ads&pid=${pid}&sam_pro_nonce=${options.samProNonce}`,
        requestType: 'json',
        adaptor: new ej.UrlAdaptor()
      });
      listGrid = $('#adsGrid').ejGrid({
        dataSource: dmAds,
        locale: ejLocale,
        allowTextWrap: true,
        allowPaging: true,
        pageSettings: {pageSize: options.itemsPerPage},
        allowSorting: true,
        allowSelection: true,
        selectionType: ej.Grid.SelectionType.Multiple,
        selectionSettings: {selectionMode: [ej.Grid.SelectionMode.Row], enableToggle: true},
        columns: [
          {field: 'aid', headerText: localeStrings.adId, isPrimaryKey: true, textAlign: ej.TextAlign.Right, width: 120},
          {field: 'title', headerText: localeStrings.name, width: 280},
          {field: 'description', headerText: localeStrings.desc},
          {field: 'asize', headerText: localeStrings.size, width: 100}
        ],
        rowSelected: function(args) {
          if(!adsSel.service) {
            adsSel.page = args.model.pageSettings.currentPage;
            const d = adsSel.pids[adsSel.page].slice(0);
            const cr = d.indexOf(args.data.aid);
            if(cr > -1) adsSel.removePid(args.data.aid);
            else adsSel.pids = args.data.aid;
          }
        },
        actionComplete: function(args) {
          const d = adsSel.ids.slice(0);
          adsSel.service = true;
          if(d.length !== 0) {
            for(let i = 0; i < this.model.currentViewData.length; i++) {
              for(let j = 0; j < d.length; j++) {
                if(d[j] === this.model.currentViewData[i].aid) {
                  this.multiSelectCtrlRequest = true;
                  this.selectRows(i);
                  if(args.requestType === 'paging') {
                    adsSel.page = args.currentPage;
                    adsSel.pids = this.model.currentViewData[i].aid;
                  }
                  else if(args.requestType === 'refresh') {
                    adsSel.page = 1;
                    adsSel.pids = this.model.currentViewData[i].aid;
                  }
                }
              }
            }
          }
          adsSel.service = false;
        }
      }).data('ejGrid');

      adsSel.sid = '';
      adsDialog.open();
    }

    $('#cancel-ads').on('click', () => {
      adsDialog.close();
      listGrid.destroy();
      cPid = 0;
    });

    $('#select-ads').on('click', () => {
      const sid = adsSel.sid;

      if(sid !== '' && cPid !== 0) {
        $.post(ajaxurl + '?action=link_ads', {
          pid: cPid,
          sid: sid,
          sam_pro_nonce: options.samProNonce,
        }).done((data) => (grid.refreshContent()));
      }
      adsDialog.close();
      listGrid.destroy();
      cPid = 0;
    });

    let lis;
    const dm = ej.DataManager({
      url: `${ajaxurl}?action=load_places&sam_pro_nonce=${options.samProNonce}`,
      removeUrl: `${ajaxurl}?action=remove_place&sam_pro_nonce=${options.samProNonce}`,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });
    const dmChild = ej.DataManager({
      url: `${ajaxurl}?action=load_places_ads&sam_pro_nonce=${options.samProNonce}`,
      removeUrl: `${ajaxurl}?action=remove_place_ad&sam_pro_nonce=${options.samProNonce}`,
      updateUrl: `${ajaxurl}?action=update_place_ad&sam_pro_nonce=${options.samProNonce}`,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });
    const dmLookup = ej.DataManager({
      url: `${ajaxurl}?action=lookup_ads&sam_pro_nonce=${options.samProNonce}`,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor(),
      offline: true
    });
    const query = ej.Query();
    const promise = dmLookup.executeQuery(query);

    promise.done(function(e) {
      const len = e.result.count;
      const data = e.result.result;
      for(let i = 0; i < len; i++) {
        const obj = {};
        obj.text = `${data[i].aid}. ${data[i].title}`;
        obj.value = data[i].aid;
        lookup.push(obj);
      }
    });

    const grid = $('#grid').ejGrid({
      dataSource: dm,
      locale: ejLocale,
      allowTextWrap: true,
      allowPaging: true,
      pageSettings: {pageSize: options.itemsPerPage},
      allowSorting: true,
      allowFiltering: true,
      filterSettings: {filterType: 'menu'},
      allowSelection: true,
      selectionSettings: {selectionMode: [ej.Grid.SelectionMode.Row], enableToggle: true},
      editSettings: {allowDeleting: true, showDeleteConfirmDialog : true},
      toolbarSettings: {
        showToolbar: true,
        customToolbarItems: [
          {templateID: '#viewMode'},
          "Expand",
          "Collapse",
          'Refresh',
          {templateID: '#NewPlace'},
          'Edit',
          'Link',
          {templateID: "#TrashPlace"},
          {templateID: "#UnTrashPlace"}
        ],
        toolbarItems: [ej.Grid.ToolBarItems.Delete]
      },
      actionComplete: function(args) {
        const $tb = $('#grid_toolbarItems');
        let li;
        li = $('#grid_delete');
        $tb.ejToolbar('disableItem', li);
        li = $('#grid_Edit');
        $tb.ejToolbar('disableItem', li);
        li = $('#grid_Link');
        $tb.ejToolbar('disableItem', li);
        li = $('#grid_TrashPlace');
        $tb.ejToolbar('disableItem', li);
        li = $('#grid_UnTrashPlace');
        $tb.ejToolbar('disableItem', li);
      },
      recordClick: function(args) {
        const $tb = $('#grid_toolbarItems');
        let li;
        const recs = this.getSelectedRecords();
        const action = (recs.length === 0) ? 'disableItem' : 'enableItem';
        li = $('#grid_delete');
        $tb.ejToolbar(action, li);
        li = $('#grid_Edit');
        $tb.ejToolbar(action, li);
        li = $('#grid_Link');
        $tb.ejToolbar(action, li);
        li = $('#grid_TrashPlace');
        $tb.ejToolbar(action, li);
        li = $('#grid_UnTrashPlace');
        $tb.ejToolbar(action, li);
      },
      toolbarClick: function (args) {
        const tbarObj = $(args.target);
        const rec = this.getSelectedRecords();
        if (tbarObj.hasClass("Expand"))
          this.expandAll();
        else if (tbarObj.hasClass("Collapse"))
          this.collapseAll();
        else if (tbarObj.hasClass("Refresh")) {
          const sel = parseInt(ddList.getSelectedValue(), 10);
          if(sel === 0) grid._disabledToolItems.push(lis[6]);
          else if(sel === 1) grid._disabledToolItems.push(lis[5]);
          this.refreshContent();
        }
        else if(tbarObj.hasClass('Edit')) {
          if(rec.length > 0) {
            const item = rec[0].pid;
            document.location = options.editorUrl + item;
          }
        }
        else if (tbarObj.hasClass('place-to-trash') || tbarObj.hasClass('place-from-trash')) {
          const toFrom = ((tbarObj.hasClass('place-to-trash')) ? 1 : 0);
          if (rec.length > 0) {
            const pid = parseInt(rec[0].pid, 10);
            const trash = parseInt(rec[0].trash, 10);

            if (trash !== toFrom) {
              $.post(ajaxurl, {
                action: 'trash_place',
                pid: pid,
                trash: toFrom,
                sam_pro_nonce: options.samProNonce
              }).done((data) => {
                const sel = parseInt(ddList.getSelectedValue(), 10);
                if(sel === 0) grid._disabledToolItems.push(lis[6]);
                else if(sel === 1) grid._disabledToolItems.push(lis[5]);
                grid.refreshContent();
              });
            }
          }
        }
        else if(tbarObj.hasClass('Link') && args.model.selectedRowIndex !== -1) {
          const currentPid = args.model.currentViewData[args.model.selectedRowIndex].pid;
          getList(currentPid);
        }
      },
      columns: [
        {
          field: 'pid',
          headerText: localeStrings.id,
          isPrimaryKey: true,
          foreignKeyField: 'pid',
          textAlign: ej.TextAlign.Right,
          width: 120
        },
        {field: 'title', headerText: localeStrings.name, width: 250},
        {field: 'description', headerText: localeStrings.desc},
        {field: 'psize', headerText: localeStrings.size, width: 200},
        {field: 'stat', headerText: localeStrings.status, textAlign: ej.TextAlign.Center, allowFiltering: false, width: 100},
        {field: 'trash', headerText: 'Trash', visible: false}
      ],
      create: function (args) {
        const $toolbar = $('#grid_toolbarItems');
        lis = $toolbar.find("li");
        $('.Expand').parent('li').attr('title', localeStrings.expand);
        $('.Collapse').parent('li').attr('title', localeStrings.collapse);
        $('.Refresh').parent('li').attr('title', localeStrings.refresh);
        $('.Edit').parent('li').attr('title', localeStrings.edit);
        $('#view-mode').parent('li').attr('title', localeStrings.viewMode);
        $('.place-to-trash').parent('li').attr('title', localeStrings.moveToTrash);
        $('.place-from-trash').parent('li').attr('title', localeStrings.restoreFromTrash);
        $('.new-ad').parent('li').attr('title', localeStrings.newPlace);
        $('.Link').parent('li').attr('title', localeStrings.linkAds);
      },
      childGrid: {
        dataSource: dmChild,
        locale: ejLocale,
        queryString: "pid",
        allowSorting: false,
        allowSelection: true,
        selectionSettings: {selectionMode: [ej.Grid.SelectionMode.Row], enableToggle: true},
        editSettings: {allowEditing: true, allowDeleting: true, showDeleteConfirmDialog : true},
        toolbarSettings: {
          showToolbar: true,
          toolbarItems: [
            "edit",
            ej.Grid.ToolBarItems.Update,
            ej.Grid.ToolBarItems.Cancel
          ],
          customToolbarItems: [
            {templateID: "#Trash"},
            'Edit_Ad'
          ]
        },
        columns: [
          {field: 'pid', headerText: 'Place ID', isPrimaryKey: true, visible: false},
          {
            field: 'aid',
            headerText: localeStrings.adId,
            isPrimaryKey: true,
            allowEditing: false,
            textAlign: ej.TextAlign.Right,
            width: 100
          },
          {field: 'title', headerText: localeStrings.name, allowEditing: false, width: 250},
          {field: 'description', headerText: localeStrings.desc, allowEditing: false},
          {
            field: 'weight',
            headerText: localeStrings.weight,
            textAlign: ej.TextAlign.Right,
            allowEditing: true,
            editType: ej.Grid.EditingType.Numeric,
            defaultValue: 10,
            width: 150
          },
          {field: 'trash', headerText: localeStrings.status, allowEditing: false, textAlign: ej.TextAlign.Center, width: 100}
        ],
        create: function (args) {
          $('.to-trash').parent('li').attr('title', localeStrings.unlinkAd);
          $('.Edit_Ad').parent('li').attr('title', localeStrings.editAd);
        },
        actionComplete: function(args) {
          const $tb = $('#' + this._id + '_toolbarItems');
          let li;
          li = $('#' + this._id + '_Trash');
          $tb.ejToolbar('disableItem', li);
          li = $('#' + this._id + '_Edit_Ad');
          $tb.ejToolbar('disableItem', li);
        },
        recordClick: function(args) {
          const $tb = $('#' + this._id + '_toolbarItems');
          let li;
          const recs = this.getSelectedRecords();
          const action = (recs.length === 0) ? 'disableItem' : 'enableItem';
          li = $('#' + this._id + '_Trash');
          $tb.ejToolbar(action, li);
          li = $('#' + this._id + '_Edit_Ad');
          $tb.ejToolbar(action, li);
        },
        toolbarClick: function(args) {
          const tbarObj = $(args.target);
          const rec = this.getSelectedRecords();
          if(tbarObj.hasClass('to-trash')) {
            $.post(ajaxurl + '?action=unlink_ad', {
              pid: args.model.currentViewData[args.model.selectedRowIndex].pid,
              aid: args.model.currentViewData[args.model.selectedRowIndex].aid,
              sam_pro_nonce: options.samProNonce
            }).done((e) => {
              if(e.success) grid.refreshContent();
            });
          }
          else if(tbarObj.hasClass('Edit_Ad')) {
            if(rec.length > 0) {
              const item = rec[0].aid;
              document.location = options.adEditorUrl + item;
            }
          }
        }
      }
    }).data('ejGrid');

    const ddList = $('#view-mode').ejDropDownList({
      selectedItemIndex: 0,
      change: function (args) {
        const sel = parseInt(this.getSelectedValue(), 10);
        if (sel !== 10) {
          $('#grid').ejGrid('model.query', new ej.Query().where('trash', ej.FilterOperators.equal, sel, 10));
        }
        else {
          $('#grid').ejGrid('model.query', new ej.Query());
        }
        if(sel === 0) grid._disabledToolItems.push(lis[6]);
        else if(sel === 1) grid._disabledToolItems.push(lis[5]);
        grid.refreshContent(true);
      }
    }).data('ejDropDownList');
  });
})(jQuery);